export class ValidationError extends Error {
    constructor(message, status, correlationId, body, date) {
        super(message);
        this.status = status;
        this.correlationId = correlationId;
        this.body = body;
        this.date = date ?? Date.now();
        this.name = "ValidationError";
    }
}

export class APIError extends Error {
    constructor(message, status, correlationId, detail, rawError) {
        super(message);
        this.status = status;
        this.correlationId = correlationId;
        this.detail = detail;
        this.rawError = rawError;
        this.name = "APIError";
    }
}

export class ServerError extends Error {
    constructor(message, status, correlationId, body, url, date) {
        super(message);
        this.status = status;
        this.correlationId = correlationId;
        this.body = body;
        this.date = date ?? Date.now();
        this.url = url;
        this.name = "ServerError";
        this.title = body ? body.title : "Unknown";
        this.detail = body ? body.detail : "Unknown";
    }
}

export class FrontendError extends Error {
    constructor(message, date) {
        super(message);
        this.date = date ?? Date.now();
        this.name = "FrontendError";
    }
}

export class GenericError extends Error {
    constructor(message, {
        title,
        subTitle,
        actionMessage,
        rawError,
        status,
        correlationId,
        date,
        action,
        showDetail,
        recoverable,
        detail,
    } = {}) {
        super(message);
        this.name = "GenericError";
        this.title = title;
        this.subTitle = subTitle;
        this.message = message;
        this.actionMessage = actionMessage;
        this.rawError = rawError;
        this.status = status;
        this.correlationId = correlationId;
        this.date = date || Date.now();
        this.action = action;
        this.showDetail = showDetail;
        this.recoverable = recoverable;
        this.detail = detail;
    }
}


